import { apiFetch } from './client';

export const listBibleReadings = (token) => apiFetch(token, '/bible-readings');

export const createBibleReading = (token, formData) =>
  apiFetch(token, '/bible-readings', { method: 'POST', body: formData });

export const updateBibleReading = (token, readingId, payload) =>
  apiFetch(token, `/bible-readings/${readingId}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });

export const deleteBibleReading = (token, readingId) =>
  apiFetch(token, `/bible-readings/${readingId}`, { method: 'DELETE' });
